import { render, staticRenderFns } from "./VacanciesPage.vue?vue&type=template&id=6111f7a2&scoped=true"
import script from "./VacanciesPage.vue?vue&type=script&lang=js"
export * from "./VacanciesPage.vue?vue&type=script&lang=js"
import style0 from "./VacanciesPage.vue?vue&type=style&index=0&id=6111f7a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6111f7a2",
  null
  
)

export default component.exports